var exports = {
  "nk": "CardsSection__hvJ94O",
  "eb": "CardsSection__gridFrame__SmySsS",
  "qn": "CardsSection__gridContent__yQ0yVE",
  "Rc": "CardsSection__gridContentWide__fEV2Tz",
  "Tq": "CardsSection__gridColumn__bMVt7E",
  "A": "CardsSection__gridItem__svrecp",
  "ky": "CardsSection__gridColumnArrowHover__r_gJSE",
};

module.exports = exports;
